<template>
  <v-item-group v-model="selectedDesignIndex" mandatory>
    <div class="pa-2">
      <p>قم باختيار تصميم الاهداء</p>
    </div>
    <div class="scrolling-div">
      <div
        class="dedication-card"
        v-for="design in dedicationDesigns"
        :key="design.id"
      >
        <v-item v-slot="{ active, toggle }">
          <v-card @click="toggle" max-width="200">
            <v-img
              :gradient="
                active ? 'to bottom, rgba(0,0,0,.2), rgba(0,0,0,.6)' : ''
              "
              class="align-center"
              contain
              :src="design.imageUrl"
              max-height="355"
              max-width="200"
            >
              <v-scroll-y-transition>
                <div v-if="active" class="text-center">
                  <v-icon color="white" x-large
                    >mdi-checkbox-marked-circle-outline</v-icon
                  >
                </div>
              </v-scroll-y-transition>
            </v-img>
          </v-card>
        </v-item>
      </div>
    </div>
  </v-item-group>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DedicationDesignsComponent",

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    showError: false,
    isLoading: false,
    selectedDesignIndex: null,
  }),

  //********************** */
  computed: {
    ...mapGetters({
      dedicationDesigns: "Catalog/dedicationDesigns",
    }),
  },

  watch: {
    selectedDesignIndex: function (val) {
        if(val || val == 0){
            let selectedDesign = this.dedicationDesigns[val];
            this.$emit('dedicationDesignSelected', selectedDesign);
        }
    },
  },
  //********************** */
  methods: {
    loadData: async function () {
      this.isLoading = true;
      try {
        await this.$store.dispatch("Catalog/loadDedicationDesigns");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isLoading = false;
    },
  },

  //*********************** */
  async mounted() {
    await this.loadData();
  },
};
</script>

<style scoped>
.scrolling-div {
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
  margin: 0px;
}
.scrolling-div::-webkit-scrollbar {
  display: none;
}

.dedication-card {
  width: 40%;
  display: inline-block;
  margin: 10px;
  vertical-align: top;
}
</style>>
